import HelpIcon from '@mui/icons-material/Help';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Cancel, CheckCircle, ChecklistOutlined, Error } from '@/ui/primitives';
import type { SvgIconComponent } from '@mui/icons-material';

export const getStatusIconComponent = (status?: string | null): SvgIconComponent => {
  if (!status) return HelpIcon;
  if (status === 'passed') return CheckCircle;
  if (status === 'completed') return CheckCircle;
  if (status === 'errored') return Error;
  if (status === 'failed') return Cancel;
  if (status === 'skipped') return RemoveCircleIcon;
  if (status === 'untested') return HelpIcon;
  return ChecklistOutlined;
};
